// react
import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

// third-party
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useSelector } from 'react-redux';

// data stubs
import theme from '../../data/theme';

export default function AccountPagePassword() {
    const userid = localStorage.getItem('user_id');
    const [password, setPassword] = useState('');
    const [oldpassword, setOldPassword] = useState('');
    const [confrimPassword, setConfirmPassword] = useState('');
    const [load, setLoad] = useState(false);

    // Eye toggle visibility states
    const [showOldPass, setShowOldPass] = useState(false);
    const [showNewPass, setShowNewPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);

    const { token } = useSelector((state) => state.auth);

    const isMatch = password && confrimPassword && password === confrimPassword;
    const isMismatch = password && confrimPassword && password !== confrimPassword;

    const handleClear = () => {
        setOldPassword('');
        setPassword('');
        setConfirmPassword('');
    };

    const resetPass = async (e) => {
        e.preventDefault();

        if (!oldpassword) {
            toast.error('Mohon masukkan password lama Anda saat ini!');
            return;
        }

        if (!password || !confrimPassword) {
            toast.error('Mohon masukkan password baru dan konfirmasi password!');
            return;
        }

        if (password.length < 6) {
            toast.error('Password baru minimal 6 karakter!');
            return;
        }

        if (password !== confrimPassword) {
            toast.error('Konfirmasi password tidak cocok dengan password baru!');
            return;
        }

        let body = { old_password: oldpassword, new_password: confrimPassword };

        try {
            setLoad(true);

            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            await axios.post(
                `${process.env.REACT_APP_HOST_API}/users/ganti-password/${userid}`,
                body,
                { headers }
            );

            setLoad(false);
            setOldPassword('');
            setPassword('');
            setConfirmPassword('');
            toast.success('Password berhasil diperbarui!');
        } catch (error) {
            console.error(error);
            setLoad(false);

            let errorMsg =
                error.code === 'ERR_NETWORK'
                    ? 'Gangguan jaringan, mohon periksa koneksi Anda'
                    : error.response
                        ? error.response.data?.message || error.response.data?.error || 'Gagal mengubah password'
                        : 'Terjadi kesalahan sistem';
            toast.error(errorMsg);
        }
    };

    return (
        <div className="password-page-wrapper">
            <Helmet>
                <title>{`Ganti Kata Sandi | ${theme.name}`}</title>
            </Helmet>

            {/* Header Card (Hidden on Mobile) */}
            <div className="password-header-card d-none d-lg-flex">
                <div className="password-header__content">
                    <div className="password-header__icon-box">
                        <i className="fas fa-shield-alt" />
                    </div>
                    <div className="password-header__text">
                        <h3>Keamanan & Ganti Password</h3>
                        <p>Kelola keamanan akun Anda dengan memperbarui kata sandi secara berkala</p>
                    </div>
                </div>
            </div>

            {/* Main Form Box */}
            <div className="password-main-box">
                <div className="password-main-box__header">
                    <h4>
                        <i className="fas fa-key" />
                        <span>Formulir Pembaruan Kata Sandi</span>
                    </h4>
                </div>

                <div className="password-main-box__body">
                    <form onSubmit={resetPass}>
                        <div className="password-form-grid">
                            {/* Left Column: Form Inputs */}
                            <div className="password-inputs-col">
                                {/* Current Password */}
                                <div className="password-field-group">
                                    <label className="field-label" htmlFor="password-current">
                                        <span className="field-label-text">
                                            <i className="fas fa-lock" />
                                            Password Saat Ini
                                        </span>
                                    </label>
                                    <div className="field-input-wrap">
                                        <i className="field-icon fas fa-lock" />
                                        <input
                                            type={showOldPass ? 'text' : 'password'}
                                            className="form-control-modern"
                                            id="password-current"
                                            value={oldpassword}
                                            placeholder="Masukkan kata sandi lama Anda"
                                            onChange={(e) => setOldPassword(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="field-toggle-btn"
                                            onClick={() => setShowOldPass(!showOldPass)}
                                            tabIndex="-1"
                                            title={showOldPass ? 'Sembunyikan password' : 'Tampilkan password'}
                                        >
                                            <i className={`fas ${showOldPass ? 'fa-eye-slash' : 'fa-eye'}`} />
                                        </button>
                                    </div>
                                </div>

                                {/* New Password */}
                                <div className="password-field-group">
                                    <label className="field-label" htmlFor="password-new">
                                        <span className="field-label-text">
                                            <i className="fas fa-key" />
                                            Password Baru
                                        </span>
                                        {password && password.length < 6 && (
                                            <span style={{ fontSize: '0.75rem', color: '#dc2626' }}>
                                                Min. 6 karakter
                                            </span>
                                        )}
                                    </label>
                                    <div className="field-input-wrap">
                                        <i className="field-icon fas fa-key" />
                                        <input
                                            type={showNewPass ? 'text' : 'password'}
                                            className="form-control-modern"
                                            id="password-new"
                                            value={password}
                                            placeholder="Minimal 6 karakter"
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="field-toggle-btn"
                                            onClick={() => setShowNewPass(!showNewPass)}
                                            tabIndex="-1"
                                            title={showNewPass ? 'Sembunyikan password' : 'Tampilkan password'}
                                        >
                                            <i className={`fas ${showNewPass ? 'fa-eye-slash' : 'fa-eye'}`} />
                                        </button>
                                    </div>
                                </div>

                                {/* Confirm New Password */}
                                <div className="password-field-group">
                                    <label className="field-label" htmlFor="password-confirm">
                                        <span className="field-label-text">
                                            <i className="fas fa-check-double" />
                                            Konfirmasi Password Baru
                                        </span>
                                        {isMatch && (
                                            <span className="password-match-badge match">
                                                <i className="fas fa-check-circle" /> Password cocok
                                            </span>
                                        )}
                                        {isMismatch && (
                                            <span className="password-match-badge mismatch">
                                                <i className="fas fa-times-circle" /> Belum sama
                                            </span>
                                        )}
                                    </label>
                                    <div className="field-input-wrap">
                                        <i className="field-icon fas fa-check-double" />
                                        <input
                                            type={showConfirmPass ? 'text' : 'password'}
                                            className="form-control-modern"
                                            id="password-confirm"
                                            value={confrimPassword}
                                            placeholder="Ulangi password baru Anda"
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="field-toggle-btn"
                                            onClick={() => setShowConfirmPass(!showConfirmPass)}
                                            tabIndex="-1"
                                            title={showConfirmPass ? 'Sembunyikan password' : 'Tampilkan password'}
                                        >
                                            <i className={`fas ${showConfirmPass ? 'fa-eye-slash' : 'fa-eye'}`} />
                                        </button>
                                    </div>
                                </div>

                                {/* Actions Row */}
                                <div className="password-actions-row">
                                    <button
                                        disabled={load}
                                        type="submit"
                                        className="btn-password-submit"
                                    >
                                        {load ? (
                                            <i className="fas fa-spinner fa-spin" />
                                        ) : (
                                            <>
                                                <i className="fas fa-shield-alt" />
                                                <span>Simpan Password Baru</span>
                                            </>
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-password-reset"
                                        onClick={handleClear}
                                        disabled={load || (!oldpassword && !password && !confrimPassword)}
                                    >
                                        <i className="fas fa-redo-alt" />
                                        <span>Reset Input</span>
                                    </button>
                                </div>
                            </div>

                            {/* Right Column: Security Guidance */}
                            <div className="password-guide-col">
                                <div className="password-tips-card">
                                    <h5 className="tips-title">
                                        <i className="fas fa-lightbulb" />
                                        <span>Tips Keamanan Kata Sandi</span>
                                    </h5>
                                    <ul className="tips-list">
                                        <li>
                                            <div className="tip-check">
                                                <i className="fas fa-check" />
                                            </div>
                                            <span>Gunakan kombinasi minimal 6 sampai 12 karakter.</span>
                                        </li>
                                        <li>
                                            <div className="tip-check">
                                                <i className="fas fa-check" />
                                            </div>
                                            <span>Sertakan perpaduan huruf besar, huruf kecil, dan angka.</span>
                                        </li>
                                        <li>
                                            <div className="tip-check">
                                                <i className="fas fa-check" />
                                            </div>
                                            <span>Hindari menggunakan nama, tanggal lahir, atau nomor HP.</span>
                                        </li>
                                        <li>
                                            <div className="tip-check">
                                                <i className="fas fa-check" />
                                            </div>
                                            <span>Ganti kata sandi Anda secara berkala demi keamanan belanja.</span>
                                        </li>
                                    </ul>

                                    <div className="tips-alert">
                                        <i className="fas fa-exclamation-triangle" />
                                        <span>
                                            Hokky Bangunan tidak pernah meminta kata sandi Anda melalui telepon, SMS, atau WhatsApp.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
